import React from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setRenderWidgetInfoModal } from '../../Redux/Actions/appConfigAction';
import { getCleanUrl } from '../../utils/Helper';
import CustomModal_Right from '../customModal/customModal_Right';
import { CROSS } from '../../assets';
import RenderHTML from 'react-native-render-html';

const InfoModalWidget_Landscape = () => {
    const {width} = useWindowDimensions();

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { modalData } = useSelector(state => state.appConfigSlice.renderWidgetInfoModal);
    const widgetMetaHtmlId = modalData?.widgetMetaHtmlId;

    const handleClose = () => {
        dispatch(setRenderWidgetInfoModal(false));
    };

    const customGuestRequestHeaderTitleStyle = getStyles(['widgetInfoModalTitle_landscape', `widgetInfoModalTitle_landscape_${widgetMetaHtmlId}`]);
    const customGuestRequestTitleStyle = getStyles(['widgetInfoModalDescription_landscape', `widgetInfoModalDescription_landscape_${widgetMetaHtmlId}`]);

    return (
        <CustomModal_Right onRequestClose={handleClose}>
            <View style={getStyles(['widgetInfoModalContainer_landscape', `widgetInfoModalContainer_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalContainer_landscape widgetInfoModalContainer_landscape_${widgetMetaHtmlId}`}>
                {/* Close Button */}

                <CustomPressable
                    onPress={handleClose}
                    style={getStyles(['widgetInfoModalCloseBtn_landscape', `widgetInfoModalCloseBtn_landscape_${widgetMetaHtmlId}`])}
                    id={`widgetInfoModalCloseBtn_landscape widgetInfoModalCloseBtn_landscape_${widgetMetaHtmlId}`}
                >
                    <ImageComp source={CROSS} style={getStyles(["widgetInfoModalCloseBtnImg_landscape", `widgetInfoModalCloseBtnImg_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalCloseBtnImg_landscape widgetInfoModalCloseBtnImg_landscape_${widgetMetaHtmlId}`} />
                </CustomPressable>

                
                {/* Header Image */}
                {modalData?.widgetHeaderImageUrl && (
                    <View style={getStyles(['widgetInfoModalImageWrapper_landscape', `widgetInfoModalImageWrapper_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalImageWrapper_landscape widgetInfoModalImageWrapper_landscape_${widgetMetaHtmlId}`}>
                        <ImageComp
                            source={getCleanUrl(modalData.widgetHeaderImageUrl)}
                            style={getStyles(['widgetInfoModalHeaderImage_landscape', `widgetInfoModalHeaderImage_landscape_${widgetMetaHtmlId}`])}
                            id={`widgetInfoModalHeaderImage_landscape widgetInfoModalHeaderImage_landscape_${widgetMetaHtmlId}`}
                        />
                    </View>
                )}


                {/* Content */}
                <View style={getStyles(['widgetInfoModalContent_landscape', `widgetInfoModalContent_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalContent_landscape widgetInfoModalContent_landscape_${widgetMetaHtmlId}`}>
                    {modalData?.contentTitle && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={Array.isArray(customGuestRequestHeaderTitleStyle.fontFamilyArr) ? {...customGuestRequestHeaderTitleStyle, fontFamily: customGuestRequestHeaderTitleStyle.fontFamilyArr[0]} : customGuestRequestHeaderTitleStyle}
                            source={{html: modalData?.contentTitle}}
                            systemFonts={ Array.isArray(customGuestRequestHeaderTitleStyle.fontFamilyArr) ? customGuestRequestHeaderTitleStyle.fontFamilyArr : [customGuestRequestHeaderTitleStyle.fontFamily]}
                            id={`widgetInfoModalTitle_landscape`}
                        />
                    )}
                    {modalData?.contentDescription && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? {...customGuestRequestTitleStyle, fontFamily: customGuestRequestTitleStyle.fontFamilyArr[0]} : customGuestRequestTitleStyle}
                            source={{html: modalData?.contentDescription}}
                            systemFonts={ Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? customGuestRequestTitleStyle.fontFamilyArr : [customGuestRequestTitleStyle.fontFamily]}
                            id={`widgetInfoModalDescription_landscape`}
                        />
                    )}
                </View>
            </View>
        </CustomModal_Right>
    );
};

export default InfoModalWidget_Landscape;
